import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'oaibox-tdd-option',
    templateUrl: './tdd-option.component.html',
    styleUrls: ['./tdd-option.component.css']
})
export class TddOptionComponent implements OnChanges {

  @Input() public tddConfigOption?: string;

  public tddConfigArray?: string[];

  ngOnChanges(changes: SimpleChanges): void {
    this.tddConfigArray = this.tddConfigOption ? Array.from(this.tddConfigOption) : undefined;
  }
}
